import { gql, useMutation } from '@apollo/client'
import { useNavigate } from '@reach/router'
import { useNotification } from '@btime/react-messager'

import { minicrudsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertMinicrud($input: MinicrudInput) {
    upsertMinicrud(input: $input) {
      id
      name
    }
  }
`

export const useSaveMinicrud = (entity, onSuccess) => {
  const notify = useNotification()
  const navigate = useNavigate()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Minicruds'], client: minicrudsClient })

  const handleRequest = name => {
    const input = { name, entity }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (!!onSuccess) onSuccess(resp.data?.upsertMinicrud)
      } else {
        notify.error({ title: 'Ocorreu um erro ao salvar!' })
      }
    })
  }

  return [handleRequest, state]
}
